// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"3256cce7","726":"2efc1f8a"}[chunkId] + ".chunk.js";
};